import mementor from "../Assets/Projects/mementor.png";
import handsfree from "../Assets/Projects/handsfree.png";

export const projects = [
  {
    id: "mementor",
    featured: true,
    imgPath: mementor,
    title: "Mementor",
    context: "HackMIT, 2025",
    headline: "Assistive software for dementia care: face, sound, place, and a caretaker on the other end.",
    description:
      "I designed a multi-service backend for an AI-powered dementia-care app: a face-recognition service and an MCP server for identification in the moment, then event-driven workflows for continuous audio, language-model task reminders, and geofence alerts that reach a caretaker in time.",
    ghLink: "https://github.com/Antoine-Lafrance/HackMIT",
    demoLink: null,
  },
  {
    id: "handsfree",
    featured: false,
    imgPath: handsfree,
    title: "HandsFree",
    context: "Cornell BigRedHacks, 2025",
    headline: "The hand as an interface: 15-30 frames a second, under a hundred milliseconds.",
    description:
      "A gesture engine on MediaPipe, with rule-based classification and a live dashboard: camera streaming, remappable gestures, and cross-platform control for media and apps. Built at Cornell BigRedHacks.",
    ghLink: "https://github.com/nicoleluo7/BigRedHacks",
    demoLink: null,
  },
];

export const featuredProject = projects.find((p) => p.featured);
export const otherProjects = projects.filter((p) => !p.featured);
